import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { createBlock, getBlockType, parse } from '@wordpress/blocks';
import { useSelect, useDispatch } from '@wordpress/data';
/**
 * Internal dependencies
 */

import { store as blockDirectoryStore } from '../../store';
export default function InstallButton(_ref) {
  var attributes = _ref.attributes,
      block = _ref.block,
      clientId = _ref.clientId;
  var isInstallingBlock = useSelect(function (select) {
    return select(blockDirectoryStore).isInstalling(block.id);
  });

  var _useDispatch = useDispatch(blockDirectoryStore),
      installBlockType = _useDispatch.installBlockType;

  var _useDispatch2 = useDispatch('core/block-editor'),
      replaceBlock = _useDispatch2.replaceBlock;

  return createElement(Button, {
    onClick: function onClick() {
      return installBlockType(block).then(function (success) {
        if (success) {
          var blockType = getBlockType(block.name);

          var _parse = parse(attributes.originalContent),
              _parse2 = _slicedToArray(_parse, 1),
              originalBlock = _parse2[0];

          if (originalBlock) {
            replaceBlock(clientId, createBlock(blockType.name, originalBlock.attributes, originalBlock.innerBlocks));
          }
        }
      });
    },
    disabled: isInstallingBlock,
    isBusy: isInstallingBlock,
    isPrimary: true
  }, sprintf(
  /* translators: %s: block name */
  __('Install %s'), block.title));
}
//# sourceMappingURL=install-button.js.map